export const table_titles = [
	{ name: "#", size: 10, order: "" },
	{ name: "Nombre", size: 15, order: "name" },
	{ name: "Bodegas", size: 10, order: "name" },
	{ name: "Región", size: 10, order: "" },
	{ name: "Comuna", size: 10, order: "" },
	{ name: "# Hectárea", size: 10, order: "" },
	{ name: "Hora Apertura", size: 10, order: "time_open" },
	{ name: "Hora Cierre", size: 10, order: "time_close" },
	{ name: "Acción", size: 10, order: "" },
];

export const base_list = {
	page: 1,
	paginate: 10,
	order: "name",
	orderType: "desc",
	type: "settings",
};

export const base_element = {
	id: "",
	name: "",
	customer_id: "",
	estates: [],
	hectares: "",
	time_open: "",
	time_close: "",
	notification_range: "",
	day_selection: false,
	days: [],
	seasons: [],
	region: "",
	locality: "",
};

export const customStyles = {
	menuPortal: (base) => ({
		...base,
		zIndex: 9999999,
	}),
	menu: (provided) => ({ ...provided, zIndex: 9999999 }),
};
